import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function WhatsAppButton() {
  const whatsappUrl = 'https://wa.me/5492995192151?text=%C2%A1Hola!%20Vi%20la%20web%20y%20quiero%20reservar%20un%20turno';
  return <motion.a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-16 h-16 bg-gold text-night-900 rounded-full shadow-[0_0_20px_rgba(212,175,55,0.4)] hover:bg-gold-light transition-colors duration-300" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 1,
    type: 'spring',
    stiffness: 200,
    damping: 20
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.9
  }} data-id="element-138">
      <motion.div animate={{
      boxShadow: ['0 0 0 0 rgba(212, 175, 55, 0.7)', '0 0 0 20px rgba(212, 175, 55, 0)']
    }} transition={{
      duration: 2,
      repeat: Infinity
    }} className="absolute inset-0 rounded-full" data-id="element-139" />
      <MessageCircle size={32} className="relative z-10" data-id="element-140" />
    </motion.a>;
}